var BrandclubStoreConfigUtils = /** @class */ (function () {
    function BrandclubStoreConfigUtils() {
    }
    BrandclubStoreConfigUtils.getAppStage = function () {
        var _a;
        var nodeEnv = ((_a = import.meta.env) === null || _a === void 0 ? void 0 : _a.MODE) || process.env.NODE_ENV;
        if (nodeEnv === 'development') {
            return 'localhost';
        }
        var origin = window.location.origin;
        if (origin.includes('beta.brandclub') || origin.includes('-beta.') || origin.includes('beta-')) {
            return 'beta';
        }
        if (origin.includes('gamma.brandclub') || origin.includes('-gamma.') || origin.includes('gamma-')) {
            return 'gamma';
        }
        return 'prod';
    };
    BrandclubStoreConfigUtils.getWebAppId = function () {
        return window.location.hostname;
    };
    BrandclubStoreConfigUtils.getBaseDomain = function () {
        // Split the hostname into parts
        var parts = window.location.hostname.split('.');
        // If it's an IP address or a localhost, return the full hostname
        if (parts.length === 1 || parts[0] === 'localhost') {
            return window.location.hostname;
        }
        // Handle typical domains (like example.com) or complex domains (like example.co.uk)
        var topLevelDomainLength = parts[parts.length - 1].length === 2 && parts[parts.length - 2].length === 2
            ? 3 // handles two-level TLDs like co.uk
            : 2;
        // Slice to get the base domain
        return parts.slice(-topLevelDomainLength).join('.');
    };
    BrandclubStoreConfigUtils.getApiHostName = function () {
        return "".concat(window.location.origin, "/api-rewards");
    };
    BrandclubStoreConfigUtils.getServerSideSyncHostName = function () {
        return "".concat(window.location.origin, "/api-retailer-sync");
    };
    BrandclubStoreConfigUtils.getGoogleMapsApiKey = function () {
        return 'AIzaSyDIvKiFNOD6JC_3ZXMeE4rtPVw49BFanJg';
    };
    BrandclubStoreConfigUtils.getGoogleMapsMapId = function () {
        return '6b6881fc70e2cb88'; // Created in google cloud console
    };
    BrandclubStoreConfigUtils.getEdgeCachedApiHostName = function () {
        return "".concat(window.location.origin, "/api-rewards");
    };
    BrandclubStoreConfigUtils.getGraphQlUri = function () {
        var base = this.getApiHostName();
        return "".concat(base, "/graphql");
    };
    BrandclubStoreConfigUtils.getServerSideSyncGraphQlUri = function () {
        var base = this.getServerSideSyncHostName();
        return "".concat(base, "/graphql");
    };
    return BrandclubStoreConfigUtils;
}());

export { BrandclubStoreConfigUtils as default };
//# sourceMappingURL=brandclubStoreConfigUtils.js.map
